import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PeopleIcon from '@material-ui/icons/People'
import HistoryIcon from '@material-ui/icons/History'
import { IoIosShirt } from 'react-icons/io';
import BatteryUnknown from '@material-ui/icons/BatteryUnknown'
import { FaFileInvoiceDollar } from 'react-icons/fa';

import { connect } from 'react-redux';
import * as actionCreators from '../../actions/sales';
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';



function mapStateToProps(state) {
  return {
    status: state.sales.currentView

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}



@connect(mapStateToProps, mapDispatchToProps)
class SalesDrawer extends React.Component {
    constructor(props){
        super(props)
    }

    render() {
        return (
        <List>
          <ListItem button key='clients' onClick={this.props.switchSalesView}>
            <ListItemIcon><PeopleIcon /></ListItemIcon>
            <ListItemText primary='Clientes' />
          </ListItem>
          <ListItem button key='Productos' onClick={this.props.switchSalesView}>
            <ListItemIcon><IoIosShirt size={28}/></ListItemIcon>
            <ListItemText primary='Productos' />
          </ListItem>
          <ListItem button key='Logistica' onClick={this.props.switchSalesView}>
            <ListItemIcon><BatteryUnknown /></ListItemIcon>
            <ListItemText primary='Logistica' />
          </ListItem>
          <ListItem button key='Facturacion' onClick={this.props.switchSalesView}>
            <ListItemIcon><FaFileInvoiceDollar size={25}/></ListItemIcon>
            <ListItemText primary='Facturacion' />
          </ListItem>
         
        </List>
        )
    }
}
export default SalesDrawer


// WEBPACK FOOTER //
// ./src/components/Drawers/SalesDrawer.js